<template lang="pug">
  .row.g-0
    .product-col.col-md-4(
      v-for="(item, index) in products"
      :key="index"
    )
      product-item(
        :item="item"
        :type="`2`"
      )

</template>

<script>
import axios from 'axios'
import ProductItem from './ProductItem.vue'

export default {
  components: { ProductItem },

  data: () => ({
    products: []
  }),

  mounted() {
    axios
      .get(`${UGO.api.url}v1/product/search?cat_id=39&per_page=3`)
      .then(({ data }) => {
        this.products = data.data
      })
  },
}
</script>

